import { Heart } from "lucide-react";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer data-testid="footer" className="bg-stone-900 text-stone-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img
                src="https://customer-assets.emergentagent.com/job_kacinoe-health-shop/artifacts/d94t0l0x_Logo%20Sante%20Kacinoe.png"
                alt="Santé KACINOÉ"
                className="h-32 w-auto brightness-110"
              />
            </div>
            <p className="text-stone-400 text-sm leading-relaxed">
              Votre partenaire santé en Côte d'Ivoire. Des compléments alimentaires premium pour une vie saine et équilibrée.
            </p>
          </div>

          {/* Links */}
          <div>
            <h4 className="text-white font-semibold mb-4 text-sm tracking-wide uppercase">
              Liens rapides
            </h4>
            <ul className="space-y-2.5">
              <li>
                <a href="#produits" className="text-stone-400 hover:text-[#6C3FC5] transition-colors text-sm">
                  Nos produits
                </a>
              </li>
              <li>
                <a href="#temoignages" className="text-stone-400 hover:text-[#6C3FC5] transition-colors text-sm">
                  Témoignages
                </a>
              </li>
              <li>
                <a href="#contact" className="text-stone-400 hover:text-[#6C3FC5] transition-colors text-sm">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-white font-semibold mb-4 text-sm tracking-wide uppercase">
              Informations
            </h4>
            <ul className="space-y-2.5">
              <li>
                <a href="#" className="text-stone-400 hover:text-[#6C3FC5] transition-colors text-sm">
                  Mentions légales
                </a>
              </li>
              <li>
                <a href="#" className="text-stone-400 hover:text-[#6C3FC5] transition-colors text-sm">
                  Politique de confidentialité
                </a>
              </li>
              <li>
                <a href="#" className="text-stone-400 hover:text-[#6C3FC5] transition-colors text-sm">
                  Conditions générales de vente
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-stone-800 mt-10 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-stone-500 text-xs">
            &copy; {currentYear} Santé KACINOÉ. Tous droits réservés.
          </p>
          <p className="text-stone-500 text-xs flex items-center gap-1">
            Fait avec <Heart size={12} className="text-[#6C3FC5]" /> en Côte d'Ivoire
          </p>
        </div>
      </div>
    </footer>
  );
}
